import { create } from 'zustand';

export type MainTab = 'explainer' | 'reader' | 'tasks' | 'graph' | 'gallery';
export type PersonaRole = 'executive' | 'po' | 'architect' | 'developer';

interface LightboxState {
  isOpen: boolean;
  svgContent: string | null;
  diagramTitle: string | null;
  scale: number;
  translateX: number;
  translateY: number;
}

interface UIState {
  activeTab: MainTab;
  selectedRole: PersonaRole;
  isSidebarOpen: boolean;
  lightbox: LightboxState;

  setActiveTab: (tab: MainTab) => void;
  setSelectedRole: (role: PersonaRole) => void;
  setSidebarOpen: (isOpen: boolean) => void;
  openLightbox: (svgContent: string, title?: string) => void;
  closeLightbox: () => void;
  updateLightboxTransform: (scale: number, translateX: number, translateY: number) => void;
  resetLightboxTransform: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  activeTab: 'explainer',
  selectedRole: 'executive',
  isSidebarOpen: true,
  lightbox: {
    isOpen: false,
    svgContent: null,
    diagramTitle: null,
    scale: 1.0,
    translateX: 0,
    translateY: 0,
  },

  setActiveTab: (activeTab) => set({ activeTab }),
  setSelectedRole: (selectedRole) => set({ selectedRole }),
  setSidebarOpen: (isSidebarOpen) => set({ isSidebarOpen }),

  openLightbox: (svgContent, diagramTitle) =>
    set({
      lightbox: {
        isOpen: true,
        svgContent,
        diagramTitle: diagramTitle || 'Diagram Lightbox View',
        scale: 1.0,
        translateX: 0,
        translateY: 0,
      },
    }),

  closeLightbox: () =>
    set((state) => ({
      lightbox: { ...state.lightbox, isOpen: false },
    })),

  updateLightboxTransform: (scale, translateX, translateY) =>
    set((state) => ({
      lightbox: { ...state.lightbox, scale, translateX, translateY },
    })),

  resetLightboxTransform: () =>
    set((state) => ({
      lightbox: { ...state.lightbox, scale: 1.0, translateX: 0, translateY: 0 },
    })),
}));
